import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'

const ToggleSwitch = ({ title = '', handleChange, component = '', isChecked = false }) => {
  return (
    <>
        <span className='mr-01'>{title}</span>
        <label className={`${styles.switch}`}>
            <input type="checkbox" checked={isChecked} onChange={() => handleChange(component)} />
            <span className={`${styles.slider} ${styles.round}`}></span>
        </label>
    </>
  )
}

ToggleSwitch.propTypes = {
  title: PropTypes.string,
  handleChange: PropTypes.func,
  component: PropTypes.string,
  isChecked: PropTypes.bool
}

export default ToggleSwitch
